import React from 'react'
import { StaticImage } from 'gatsby-plugin-image'
import { Link } from 'gatsby'
import parser from 'html-react-parser'

export default function Approach({ data }) {
    const { approachLeftButtonText, approachRightButtonText, approachTitle, approachText, approachLeftButtonLink, approachRightButtonLink, approachLeftButtonExternalLink, approachRightButtonExternalLink } = data
    return (
        <div className='our-imapct-video-wrap global-comet-vid-wrap light-grey-bg'>
            <div className='container sm-container-1'>
                <div className='row'>
                    <div className='col-md-12 text-center'>
                        <figure className='abt-origins-icon mb-1'>
                            <StaticImage
                                src='../../../images/origins-icon.png'
                                alt='image'
                            />
                        </figure>
                        <div className='imapact-vid-sec our-impact-vid-sec'>
                            <h2 className='heading-level-2 mb-4 blue-color text-center'>
                                {approachTitle && parser(approachTitle)}
                            </h2>
                            <p>{approachText && parser(approachText)}</p>
                            <div className='two-btn-sec'>
                                {approachLeftButtonExternalLink ? (
                                    <a href={approachLeftButtonExternalLink} className="btn blue-outline-btn">
                                        {approachLeftButtonText}
                                    </a>
                                ) : approachLeftButtonLink ? (
                                    <Link
                                        to={approachLeftButtonLink.uri}
                                        className='btn blue-outline-btn'
                                    >
                                        {approachLeftButtonText}
                                    </Link>
                                ) : null}
                                {approachRightButtonExternalLink ? (
                                    <a href={approachRightButtonExternalLink} className="btn blue-btn">
                                        {approachRightButtonText}
                                    </a>
                                ) : approachRightButtonLink ? (
                                    <Link
                                        to={approachRightButtonLink.uri}
                                        className='btn blue-btn'
                                    >
                                        {approachRightButtonText}
                                    </Link>
                                ) : null}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
